var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-picker',_vm._g(_vm._b({attrs:{"items":_vm.items,"item-label":"name","item-value":"value"}},'simple-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }